import styled from 'styled-components';

import { device } from '@/styles/helpers';

export const ScEmptyGameList = styled.div`
  display: flex;
  background: ${({ theme }) => theme.grayDarkColor};
  justify-content: center;
  position: relative;
  overflow: hidden;
  width: 100%;
  padding: 40px 24px;
  border-radius: 8px;
  box-sizing: border-box;
  align-items: center;
  min-height: 128px;

  p {
    max-width: 512px;
    color: ${({ theme }) => theme.whiteColor};
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
  }

  .layer {
    position: absolute;
    height: auto;
    vertical-align: bottom;
    &-1 {
      width: 75px;
      left: 39px;
      bottom: 27px;
      transform: rotate(27deg);
    }
    &-2 {
      width: 175px;
      left: 183px;
      bottom: -29px;
      transform: rotate(-15deg);
    }
    &-3 {
      width: 94px;
      right: 264px;
      bottom: 21px;
      transform: rotate(-15deg);
    }
    &-4 {
      width: 158px;
      right: 76px;
      bottom: -37px;
      transform: rotate(15deg);
    }
    &-5 {
      width: 75px;
      right: -7px;
      bottom: 75px;
      transform: rotate(-18deg);
    }
  }

  @media (${device.desktop}) {
    .layer {
      &-1 {
        left: 23px;
      }
      &-2 {
        left: 93px;
      }
      &-3 {
        right: 174px;
      }
      &-4 {
        right: 16px;
      }
      &-5 {
        right: -16px;
      }
    }
  }
  @media (${device.tablet}) {
    p {
      max-width: 320px;
    }
  }
  @media (${device.mobile}) {
    .layer {
      &-1 {
        left: -7px;
        bottom: -16px;
      }
      &-2 {
        width: 120px;
        left: 32px;
      }
      &-3 {
        right: 32px;
        bottom: 24px;
      }
      &-4 {
        right: -32px;
        bottom: -32px;
        width: 112px;
      }
      &-5 {
        right: -24px;
        bottom: 72px;
      }
    }
  }
  @media (${device.mobileS}) {
    padding-bottom: 142px;
    .layer {
      &-1 {
        left: 50%;
        transform: translateX(-50%) rotate(27deg);
        bottom: -16px;
        margin-left: -120px;
      }
      &-2 {
        transform: translateX(-50%) rotate(-15deg);
        width: 130px;
        left: 50%;
        margin-left: -32px;
      }
      &-3 {
        transform: translateX(50%) rotate(-15deg);
        right: 50%;
        bottom: 46px;
        margin-right: -120px;
      }
      &-4 {
        transform: translateX(50%) rotate(15deg);
        right: 50%;
        bottom: -32px;
        width: 112px;
        margin-right: -96px;
      }
      &-5 {
        transform: translateX(50%) rotate(-18deg);
        right: 50%;
        bottom: -16px;
        margin-right: -160px;
      }
    }
  }
`;
